import { render, staticRenderFns } from "./ProfileGroup.vue?vue&type=template&id=147ef6e8&scoped=true&lang=html&"
import script from "./ProfileGroup.vue?vue&type=script&lang=js&"
export * from "./ProfileGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGroup.vue?vue&type=style&index=0&id=147ef6e8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147ef6e8",
  null
  
)

export default component.exports